import React from 'react';
import { RefreshCw } from 'lucide-react';

/**
 * Secondary action on an OCR review pane. Reads the stored scan again.
 * Outline + btn-sm so it stays inside VerificationPanelHeader (locked h-12)
 * and does not compete with the modal footer's primary action.
 */
const ExtractAgainButton = ({
  onClick,
  busy = false,
  label = 'Extract again',
  busyLabel = 'Extracting…',
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={busy}
    className="btn btn-sm btn-outline inline-flex items-center gap-1.5 disabled:opacity-60"
    title="Read this document again and update the extracted fields"
    aria-label="Extract details again"
  >
    {busy ? (
      <>
        <span className="w-3.5 h-3.5 border-2 border-current border-t-transparent rounded-full animate-spin" aria-hidden="true" />
        {busyLabel}
      </>
    ) : (
      <>
        <RefreshCw className="w-3.5 h-3.5" aria-hidden="true" />
        {label}
      </>
    )}
  </button>
);

export default ExtractAgainButton;
